
// @ts-nocheck


export const localeCodes =  [
  "it",
  "en",
  "fr"
]

export const localeLoaders = {
  "it": [],
  "en": [],
  "fr": []
}

export const vueI18nConfigs = [
  () => import("../i18n.config.ts?hash=bffaebcb&config=1" /* webpackChunkName: "__i18n_config_bffaebcb" */)
]

export const nuxtI18nOptions = {
  "experimental": {
    "localeDetector": "",
    "switchLocalePathLinkSSR": false,
    "autoImportTranslationFunctions": false
  },
  "bundle": {
    "compositionOnly": true,
    "runtimeOnly": false,
    "fullInstall": true,
    "dropMessageCompiler": false
  },
  "compilation": {
    "jit": true,
    "strictMessage": true,
    "escapeHtml": false
  },
  "customBlocks": {
    "defaultSFCLang": "json",
    "globalSFCScope": false
  },
  "vueI18n": "./i18n.config",
  "locales": [
    {
      "code": "it",
      "site": "it",
      "language": "it-IT",
      "name": "Italiano"
    },
    {
      "code": "en",
      "site": "en",
      "language": "en-US",
      "name": "English"
    },
    {
      "code": "fr",
      "site": "fr",
      "language": "fr-FR",
      "name": "Français"
    }
  ],
  "defaultLocale": "it",
  "defaultDirection": "ltr",
  "routesNameSeparator": "___",
  "trailingSlash": false,
  "defaultLocaleRouteNameSuffix": "default",
  "strategy": "prefix_except_default",
  "lazy": false,
  "langDir": null,
  "detectBrowserLanguage": {
    "alwaysRedirect": false,
    "cookieCrossOrigin": false,
    "cookieDomain": null,
    "cookieKey": "i18n_redirected",
    "cookieSecure": false,
    "fallbackLocale": "",
    "redirectOn": "root",
    "useCookie": true
  },
  "differentDomains": false,
  "baseUrl": "https://maleymontblanc.com",
  "dynamicRouteParams": false,
  "customRoutes": "config",
  "pages": {
    "sidri": {
      "it": "/sidri",
      "en": "/ciders",
      "fr": "/cidres"
    },
    "alta-quota": {
      "it": "/alta-quota",
      "en": "/high-altitude",
      "fr": "/haute-altitude"
    },
    "savoir-faire": {
      "it": "/savoir-faire",
      "en": "/savoir-faire",
      "fr": "/savoir-faire"
    },
    "contatti/index": {
      "it": "/contatti",
      "en": "/contacts",
      "fr": "/contacts"
    },
    "contatti/form-success/index": {
      "it": "/contatti/modulo-inviato",
      "en": "/contacts/form-sent",
      "fr": "/contacts/formulaire-envoye"
    },
    "contatti/form-failure/index": {
      "it": "/contatti/errore-di-invio",
      "en": "/contacts/submission-error",
      "fr": "/contacts/erreur-d-envoi"
    },
    "product/[slug]/index": {
      "it": "/prodotto/[slug]",
      "en": "/product/[slug]",
      "fr": "/produit/[slug]"
    },
    "index": {
      "it": "/",
      "en": "/",
      "fr": "/"
    }
  },
  "skipSettingLocaleOnNavigate": false,
  "types": "composition",
  "debug": false,
  "parallelPlugin": false,
  "multiDomainLocales": false,
  "i18nModules": []
}

export const normalizedLocales = [
  {
    "code": "it",
    "site": "it",
    "language": "it-IT",
    "name": "Italiano",
    "files": []
  },
  {
    "code": "en",
    "site": "en",
    "language": "en-US",
    "name": "English",
    "files": []
  },
  {
    "code": "fr",
    "site": "fr",
    "language": "fr-FR",
    "name": "Français",
    "files": []
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false

export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18n"
export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
